// ag-grid-enterprise v20.2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function naturalOrder(a, b) {
    return a - b;
}
exports.naturalOrder = naturalOrder;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ag-grid-enterprise/dist/lib/charts/util/compare.js
// module id = dHGt
// module chunks = 23